import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const apiaFinder: ThemeUICSSObject = {
  additionalFiltersModal: {
    resize: 'none',

    '.modal__main': {
      resize: 'none',
    },

    '.modal__content': {
      overflow: 'hidden',

      '&.modal__content': {
        flexDirection: 'column',
        gap: spacing(4),

        '.additionalFilters__navbar': {
          display: 'flex',
          justifyContent: 'end',
          gap: spacing(4),
        },
      },
    },
    '.additionalFiltersContent': {
      width: '100%',
      minWidth: 'min(600px, 75vw)',
      maxWidth: '600px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      gap: spacing(3),

      '.accordionElement, .accordion__item': {
        maxHeight: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 100,
        mb: spacing(0),

        '.content, .accordion__item__content': {
          overflow: 'auto',

          '&>div': {
            border: '1px solid',
            borderColor: 'palette.border.article',
            p: spacing(5),
            '& label': {
              flexDirection: 'column',
              justifyContent: 'stretch',
              textAlign: 'left',
              alignItems: 'stretch',

              span: {
                mb: spacing(1),
              },
            },
          },
        },
      },
      '#FilterTypes_content': {
        '& label': {
          mb: spacing(4),
        },
        '.confirmRow': {
          textAlign: 'right',
        },
      },
    },
  },

  '.modal__main': {
    maxHeight: responsive({ 0: '100vh', 5: '85vh', 6: '75vh' }),
    maxWidth: 'max-content',

    '&[style*="width"]': {
      maxWidth: 'unset',
    },

    '.confirm__content': {
      justifyContent: 'space-between',
      maxHeight: '100%',
      overflow: 'hidden',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',

      '.finder__content': {
        maxWidth: '100%',
        flexGrow: 100,
        border: '1px solid',
        borderColor: 'palette.border.section',
        overflow: 'auto',

        '.selection__keyHandler': {
          width: '100%',
        },
      },

      '.finder__statistics': {
        flexShrink: 0,
      },
    },
  },

  '.results': {
    mt: '7px',
  },
};

export default apiaFinder;
